export App from './App/App';
export CreateAndEditPatchPage from './CreateAndEditPatchPage/CreateAndEditPatchPage';
export DevicePage from './DevicePage/DevicePage';
export Dialog from './Dialog/Dialog';
export LoginPage from './LoginPage/LoginPage';
export MidiKeyboard from './MidiKeyboard/MidiKeyboard';
export NavBar from './NavBar/NavBar';
export OwlControl from './OwlControl/OwlControl';
export PatchTile from './PatchTile/PatchTile';
export PatchListPage from './PatchListPage/PatchListPage';
export PatchDetailsPage from './PatchDetailsPage/PatchDetailsPage';
export PatchNotFoundPage from './PatchNotFoundPage/PatchNotFoundPage';
export PatchPreview from './PatchPreview/PatchPreview';
export PatchCode from './PatchCode/PatchCode';
export PatchParameters from './PatchParameters/PatchParameters';
export SearchInput from './SearchInput/SearchInput';
export SubFilter from './SubFilter/SubFilter';



// WEBPACK FOOTER //
// ./src/containers/index.js